export const integrations = [
  {
    element: '#welcome',
    popover: {
      title: 'Welcome to Integrations',
      description: "Connect your various marketing platforms here to gain <b>centralized control</b> over your data. This allows you to efficiently track and analyze the performance of all your ads and organic posts in one powerful system",
      position: 'top',
    },
  },
  {
    element: '.social_media_type_filter',
    popover: {
      title: 'Filter by Platform Type',
      description: "Use this filter to dive deeper into your marketing data! Easily select specific platform types like <b> Organic Social, Paid Media, Paid Social, Owned Media, or Search </b> to analyze performance and focus your insights.",
      position: 'bottom',
    },
  },
  {
    element: '.platform_list',
    popover: {
      title: 'Available Platforms',
      description: "Browse the list of available platforms below. <b>Connecting them is quick and easy</b>, enabling you to immediately begin tracking the performance of your ads and content for comprehensive insights.",
      position: 'right',
    },
  },
  {
    element: '.connect_button',
    popover: {
      title: 'Connect Your Account',
      description: "Simply click this button to securely <b>authorize and connect your chosen platform account.</b> This step gives University Intelligence permission to start tracking your valuable marketing data",
      position: 'left',
    },
  },
//   {
//     element: '.link_ads_btn',
//     popover: {
//       title: 'Link Ads',
//       description: 'Use this button to link a specific ad to a campaign on the platform. This helps consolidate your performance metrics.',
//       position: 'top',
//     },
//   },
//   {
//     element: '.link_posts_btn',
//     popover: {
//       title: 'Link Organic Post',
//       description: 'This lets you link an organic post to a program under the selected client. It improves post-level tracking.',
//       position: 'top',
//     },
//   },
//   {
//   element: '.disconnect_account_btn',
//   popover: {
//     title: 'Disconnect Account',
//     description: 'Use this button to disconnect the linked platform account. After disconnecting, no data will be fetched or tracked from this platform.',
//     position: 'left',
//   },
  
// },
  {
  element: '.thank_you',
  popover: {
    title: 'Tour Completed 🎉',
    description: "Congratulations! Your tour is complete. You're now ready to harness the power of University Intelligence: start integrating platforms, linking your ads, and tracking performance to unlock actionable insights for every program. Let's grow your enrollment!.",
    position: 'top',
  }
}
];
